module.exports = __webpack_public_path__ + "assets/img/14_926_big.8f62d81e.jpg";